import { Entity } from './Entity'

export class Person extends Entity {
	constructor (payload, api) {
		super(Object.assign({}, payload, {type:"person"}), api);
	}

	/**
	 * Determine person visibility
	 *
	 * @arg other Another entity
	 *
	 * Persons are visible by those with permission
	 * "operator" and above.
	 *
	 */
	isVisibleBy (other) {
		const acceptablePermissions = [ "operator", "manager", "admin", "master" ];

		if (super.isVisibleBy(other)) {
			if (other.permissions) {
				if (acceptablePermissions.filter( p => other.permissions.includes(p) ).length > 0) {
					return true;
				}
			}
		}
		return false;
	}

	/**
	 * Determine if a person is editable by another entity
	 *
	 * @arg other Another entity
	 *
	 * Persons are editable by those with permissions
	 * "admin" or "master".
	 *
	 */
	isEditableBy (other) {
		const acceptablePermissions=  [ "admin", "master" ];

		if (super.isEditableBy(other)) {
			if (other.permissions) {
				if (acceptablePermissions.filter( p => other.permissions.includes(p) ).length > 0) {
					return true;
				}
			}
		}
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/JMan/Entity/Person.js